module.exports = __webpack_public_path__ + "media/images/aldo-logo-c353d418ac8b0a77d7d81a07bec7d5fb.png";